import { z } from "zod";

export const zLoginFormData = z.object({
  email: z.string(),
  password: z.string(),
});

export type ZLoginFormData = z.infer<typeof zLoginFormData>;
